import Repository from '../../repositories/RepositoryFactory';
const ccmLabRepository = Repository.get('ccmLabs');

export default {
	namespaced: true,
	state: {
		ccmLabsByPatientId: [],
		ccmLabsByCCMRecordId: [],
		ccmLab: null,
	},
	mutations: {
		STORE_CCM_LAB_BY_PATIENT_ID (state, payload) {
			state.ccmLabsByPatientId = payload;
		},
		STORE_CCM_LAB_BY_CCM_RECORD_ID (state, payload) {
			state.ccmLabsByCCMRecordId = payload;
		},
		STORE_CCM_LAB (state, payload) {
			state.ccmLab = payload;
		},
		UPDATE_CCM_LAB (state, payload) {
			state.ccmLab = {
				...state.ccmLab,
				...payload,
			};
		},
		UPDATE_CCM_LAB_IN_PATIENT_LIST (state, payload) {
			const index = state.ccmLabsByPatientId.findIndex((lab) => lab.id === payload.id);
			if (index !== -1) {
				state.ccmLabsByPatientId.splice(index, 1, {
					...state.ccmLabsByPatientId[index],
					...payload.body,
				});
			}
		},
		ADD_CCM_LAB_TO_PATIENT_LIST (state, payload) {
			state.ccmLabsByPatientId.unshift(payload);
		},
		REMOVE_CCM_LAB (state, id) {
			state.ccmLabsByPatientId = state.ccmLabsByPatientId.filter((lab) => lab.id !== id);
		},
	},
	actions: {
		async getCCMLabsByPatientId ({ commit }, patientId) {
			const response = await ccmLabRepository.getCCMLabsByPatientId(patientId);
			commit('STORE_CCM_LAB_BY_PATIENT_ID', response.data);
		},

		async getCCMLabsByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmLabRepository.getCCMLabsByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_LAB_BY_CCM_RECORD_ID', response.data);
		},

		async getCCMLab ({ commit }, id) {
			const response = await ccmLabRepository.getCCMLab(id);
			commit('STORE_CCM_LAB', response.data);
		},

		async addCCMLab ({ commit }, body) {
			const response = await ccmLabRepository.addCCMLab(body);
			commit('ADD_CCM_LAB_TO_PATIENT_LIST', response.data);
		},

		async updateCCMLab ({ commit }, request) {
			commit('UPDATE_CCM_LAB', request.body);
			commit('UPDATE_CCM_LAB_IN_PATIENT_LIST', request);
			return await ccmLabRepository.updateCCMLab(request.id, request.body);
		},

		async deleteCCMLab ({ commit }, id) {
			commit('REMOVE_CCM_LAB', id);
			return await ccmLabRepository.deleteCCMLab(id);
		},

		async uploadLabDocumentToAi ({ commit }, body) {
			return await ccmLabRepository.uploadLabDocumentToAi(body);
		},
	},
};
